import styled from 'styled-components'

export const AdvancedFilterStyles = styled.div`
    span.MuiButtonBase-root.MuiIconButton-root.txt-primario.icon-button-notification {
        position: relative;
    }

    span.MuiButtonBase-root.MuiIconButton-root.txt-primario.icon-button-notification span.MuiIconButton-label {
        position: relative;
    }

    #notification-menu li.MuiButtonBase-root.MuiListItem-root.MuiMenuItem-root.title-view-all-notifications.MuiMenuItem-gutters.MuiListItem-gutters.MuiListItem-button {
        background: var(--white) !important;
        -webkit-user-select: none;  /* Chrome all / Safari all */
        -moz-user-select: none;     /* Firefox all */
        -ms-user-select: none;      /* IE 10+ */
        user-select: none;          /* Likely future */
        cursor: default;
        font-size: 14px;
        font-weight: 500;
        color: #292929;
        border-bottom: 1px solid #dedede;
    }

    #notification-menu li.MuiButtonBase-root.MuiListItem-root.MuiMenuItem-root.btn-view-all-notifications.MuiMenuItem-gutters.MuiListItem-gutters.MuiListItem-button {
        text-align: center;
        align-items: center;
        justify-content: center;
        color: var(--primary);
        font-size: 14px;
        font-weight: 500;
        border-top: 1px solid #dedede;
    }

    
`

AdvancedFilterStyles.Mark = styled.div`
    background: red;
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 100%;
    right: 1px;
    top: 2px;
`

AdvancedFilterStyles.Title = styled.h1`
    font-weight: 300;
    color: var(--primary);
    margin: 0;
`